import { ReactNode } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { AppPageShell } from './AppPageShell';
import { BrandLogoLink } from './BrandLogoLink';
import { Footer } from './Footer';
import { SettingsButton } from '../UI/SettingsButton';

interface LegalPageShellProps {
  title: string;
  lastUpdated: string;
  children: ReactNode;
}

export function LegalPageShell({ title, lastUpdated, children }: LegalPageShellProps) {
  const { t, i18n } = useTranslation();

  return (
    <AppPageShell maxWidthClass="max-w-3xl">
      <header className="sticky top-0 z-50 mb-6 flex items-center justify-between bg-room-bg/80 pb-3 pt-1 backdrop-blur-sm">
        <BrandLogoLink />
        <SettingsButton variant="room" />
      </header>

      <motion.article
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="rounded-3xl border border-room-border bg-room-surface p-6 sm:p-10"
      >
        <h1 className="mb-2 text-3xl font-bold text-room-text sm:text-4xl">{title}</h1>
        <p className="mb-8 text-sm text-room-text-faint">{lastUpdated}</p>

        {i18n.language !== 'en' ? (
          <div className="mb-8 rounded-xl border border-room-accent/25 bg-room-accent-soft p-4">
            <p className="text-sm text-room-text-dim">ℹ️ {t('legal.languageNotice')}</p>
          </div>
        ) : null}

        <div className="legal-prose">{children}</div>
      </motion.article>

      <Footer variant="room" />
    </AppPageShell>
  );
}
